import _extends from "@babel/runtime/helpers/extends";
import { useEffect } from 'react';
import { StateEffect } from '@codemirror/state';
import { getDefaultExtensions } from '@uiw/react-codemirror';
import { useStore } from './store';
export var Modified = props => {
  var {
    extensions = []
  } = props;
  var {
    modified,
    view,
    dispatch
  } = useStore();
  var defaultExtensions = getDefaultExtensions();
  useEffect(() => {
    var data = {
      extensions: [...defaultExtensions, ...extensions]
    };
    if ((modified == null ? void 0 : modified.doc) !== props.value && view) {
      data.doc = props.value;
      dispatch({
        modified: _extends({}, modified, data)
      });
      var modifiedDoc = view == null ? void 0 : view.b.state.doc.toString();
      if (modifiedDoc !== props.value) {
        view.b.dispatch({
          changes: {
            from: 0,
            to: (modifiedDoc || '').length,
            insert: props.value || ''
          }
        });
      }
    }
    if ((modified == null ? void 0 : modified.selection) !== props.selection) {
      data.selection = props.selection;
      dispatch({
        modified: _extends({}, modified, data)
      });
    }
  }, [props.value, props.selection, view]);
  useEffect(() => {
    if (view) {
      view.b.dispatch({
        effects: StateEffect.appendConfig.of([...defaultExtensions, ...extensions])
      });
    }
  }, [extensions, view]);
  return null;
};